import authConfigJson from './auth0-config.json';

// Get the current origin dynamically
const getCurrentOrigin = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return import.meta.env.VITE_PUBLIC_URL || 'http://localhost:3000';
};

// Auth0 configuration with environment-aware URLs
const authConfig = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || authConfigJson.domain,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || authConfigJson.clientId,
  audience: import.meta.env.VITE_AUTH0_AUDIENCE || authConfigJson.audience,
  scope: authConfigJson.scope,
  redirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI || `${getCurrentOrigin()}/callback`,
  logoutUri: getCurrentOrigin(),
};

export default authConfig;